export const works = [
  {
    company: 'GFT Technologies',
    role: 'Senior Software Engineer',
    dateStart: 'Apr 2026',
    dateEnd: 'Present',
    totalTime: '',
    companyLogo: 'gft',
    companyUrl: 'https://www.gft.com/',
    keyPoints: [],
  },
  {
    company: 'Konrad Group',
    role: 'Software Developer II',
    dateStart: 'Jul 2025',
    dateEnd: 'Mar 2026',
    totalTime: '9 months',
    companyLogo: 'kg',
    companyUrl: 'https://www.konrad.com/',
    keyPoints: [
      'Led cross-functional agile teams to deliver new product features, ensuring quality, scope alignment, and prioritization in the implementation process.',
      'Translated high-level product requirements into clear, actionable technical specifications, bridging the gap between product, engineering, and business stakeholders.',
      'Led the mentorship of new hires as a volunteer mentor, overseeing company onboarding, task management, conducting QA, and code reviews while providing continuous technical coaching.',
    ],
  },
  {
    company: 'Konrad Group',
    role: 'Software Developer',
    dateStart: 'Jul 2024',
    dateEnd: 'Jul 2025',
    totalTime: '1 year 1 month',
    companyLogo: 'kg',
    companyUrl: 'https://www.konrad.com/',
    keyPoints: [
      'Reviewed code and provided technical guidance to interns on Java and React, ensuring alignment with company code quality standards and best practices.',
      'Implemented modular and interactive React/Typescript components integrated with Contentstack CMS, enhancing content management flexibility and user experience.',
      'Implemented API endpoints in Java Spring MVC and MuleSoft Anypoint Studio, leveraging the Anypoint Platform cloud suite for scalable API management.',
    ],
  },
  {
    company: 'Konrad Group',
    role: 'Associate Software Developer',
    dateStart: 'Jul 2023',
    dateEnd: 'Jul 2024',
    totalTime: '1 year 1 month',
    companyLogo: 'kg',
    companyUrl: 'https://www.konrad.com/',
    keyPoints: [
      'Implemented GraphQL API endpoints in Java Spring WebFlux, leveraging non-blocking reactive streams to provide high-throughput and efficient resource utilization.',
      'Fixed functionality and accessibility bugs in an existing React/Typescript project, enhancing user experience and compliance with accessibility standards.',
      'Implemented and integrated custom WordPress block components in React and PHP, engineered with hydration to enhance SEO performance.',
    ],
  },
  {
    company: 'Konrad Group',
    role: 'Full Stack Developer Intern',
    dateStart: 'Feb 2023',
    dateEnd: 'Jun 2023',
    totalTime: '5 months',
    companyLogo: 'kg',
    companyUrl: 'https://www.konrad.com/',
    keyPoints: [
      'Implemented backend REST API endpoints in Java Spring Boot using layered architecture, ensuring maintainable and scalable code.',
      'Implemented A11Y compliant accessible UI components in React/Typescript within a modular architecture, enhancing user experience and code reusability.',
      'Implemented API JWT-based authentication and role-based authorization, leveraging Google Identity services for secure and seamless user management.',
      'Designed the project SQL database and created Java Flyway database migrations to ensure consistent and version-controlled database changes.',
    ],
  },
  {
    company: 'Tecnológico de Costa Rica',
    role: 'Web Developer',
    dateStart: 'Feb 2022',
    dateEnd: 'Nov 2022',
    totalTime: '10 months',
    companyLogo: 'tec',
    companyUrl: 'https://www.tec.ac.cr/',
    keyPoints: [
      'Implemented responsive frontend web components using HTML, CSS/SASS, and JavaScript/jQuery, from Figma designs.',
      'Integrated frontend web components in Drupal CMS using PHP Twig templates.',
    ],
    workUrl: '',
  },
];
